import http from 'core/http-common'

import { IHealthLocationList } from 'types/HealthType'
import {
  IFilteredLactationRoomList,
  IGetLactationRoomTimeTableReq,
  ILactationRoomFilteredReq,
  ISaveLactationReservation,
} from 'types/LactationType'

class LactationService {
  getLactationServiceDetailByLocationId(locationId: number) {
    return http.get(`LactationService/GetByLocationId?locationId=${locationId}`)
  }

  getLactationLocations() {
    return http.get<IHealthLocationList[]>(`LactationService/GetLocationList`)
  }

  getLactationRoomFilteredList(data: ILactationRoomFilteredReq) {
    return http.post<IFilteredLactationRoomList[]>(`LactationRoom/GetFilteredList`, data)
  }

  getLactationRoomReservationTableList(data: IGetLactationRoomTimeTableReq) {
    return http.post(`LactationReservation/GetTimeTableList`, data)
  }

  saveLactationRoomReservation(data: ISaveLactationReservation) {
    return http.post(`LactationReservation/SaveReservation`, data)
  }

  /* Favorite */
  addLactationRoomFavorite(roomId: number) {
    return http.get(`FavoriteLactationRoom/Save?lactationRoomId=${roomId}`)
  }
  removeLactationRoomFavorite(roomId: number) {
    return http.get(`FavoriteLactationRoom/Delete?lactationRoomId=${roomId}`)
  }
}

export default new LactationService()
